if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }
onSubmitHandler(evt) {
  const isJournalProduct =
  this.dataset.journalProduct === 'true';
  evt.preventDefault();

  if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

  this.handleErrorMessage();

  this.submitButton.setAttribute('aria-disabled', true);
  this.submitButton.classList.add('loading');
  this.querySelector('.loading__spinner').classList.remove('hidden');

  const formData = new FormData(this.form);

  const selectedVariantId = formData.get('id');
  const quantity = parseInt(formData.get('quantity')) || 1;

  const productRoot = this.closest('product-info') || document;

  const selectedCard =
    productRoot.querySelector('.variant-card.is-selected') ||
    productRoot.querySelector('[data-variant-expanded]:not([hidden])')?.closest('.variant-card') ||
    productRoot;

  const findColorRadio = (wrapSelector) => {
    const wrap = selectedCard.querySelector(wrapSelector);
    if (!wrap) return null;

    return (
      wrap.querySelector('.variant-color-option.is-selected input[type="radio"]') ||
      wrap.querySelector('input[type="radio"]:checked')
    );
  };

  const readColorFromRadio = (radio) => {
    if (!radio) return '';

    return (
      radio.getAttribute('data-color') ||
      radio.getAttribute('data-color-2') ||
      radio.getAttribute('data-color-handle') ||
      radio.value ||
      ''
    ).trim();
  };

  const readImageFromRadio = (radio) => {
    if (!radio) return '';

    try {
      const parsed = JSON.parse(
        radio.getAttribute('data-color-images') || '[]'
      );

      if (Array.isArray(parsed) && parsed[0]) {
        return parsed[0];
      }
    } catch (error) {
      // Fall through to the single image attribute.
    }

    return radio.getAttribute('data-color-image') || '';
  };

  const color1Radio = findColorRadio('[data-variant-colors]');
  const color2Radio = findColorRadio('[data-variant-colors-2]');

  const color1 =
    readColorFromRadio(color1Radio) ||
    formData.get('properties[Color]') ||
    '';

  const color2 =
    readColorFromRadio(color2Radio) ||
    formData.get('properties[Color 2]') ||
    '';

  const color1Image =
    readImageFromRadio(color1Radio) ||
    formData.get('properties[_color_image]') ||
    '';

  const color2Image =
    readImageFromRadio(color2Radio) ||
    formData.get('properties[_color_image_2]') ||
    '';

  /*
   * ---------------------------------------------------------
   * Shopify variant lookup
   * ---------------------------------------------------------
   *
   * product.variants contains the real Shopify variant IDs.
   *
   * Example:
   * "1 Journal" + "Sage"
   *     -> 45259467751490
   *
   * "2 Journals" + "Graphite"
   *     -> 45259467915330
   */

  let productVariants = [];

  try {
    const variantsElement = this.querySelector(
      '[data-product-variants]'
    );

    if (variantsElement) {
      productVariants = JSON.parse(
        variantsElement.textContent
      );
    }
  } catch (error) {
    console.error(
      'Unable to parse product variants:',
      error
    );
  }

  const findJournalVariant = (journalType, color) => {
    if (!journalType || !color) return null;

    const normalizedJournalType = journalType.trim().toLowerCase();
    const normalizedColor = color.trim().toLowerCase();

    return (
      productVariants.find((variant) => {
        const option1 = (variant.option1 || '').trim().toLowerCase();
        const option2 = (variant.option2 || '').trim().toLowerCase();

        return (
          option1 === normalizedJournalType &&
          option2 === normalizedColor
        );
      }) || null
    );
  };

  /*
   * The selected Shopify option represents:
   *
   * option1 = "1 Journal" OR "2 Journals"
   *
   * We use that as the journal type and then combine it
   * with the custom color selections above.
   */
  let journalType = '';

  /*
   * First try to get the journal type from the selected
   * Shopify variant.
   */
  const selectedVariant = productVariants.find(
    (variant) => String(variant.id) === String(selectedVariantId)
  );

  if (selectedVariant?.option1) {
    journalType = selectedVariant.option1;
  }

  /*
   * Fallback: read the selected variant-card if necessary.
   */
  if (!journalType) {
    const variantOptionInput = selectedCard.querySelector(
      '[data-variant-option-input]'
    );

    journalType =
      variantOptionInput?.value ||
      '';
  }

  /*
   * ---------------------------------------------------------
   * Find the actual Shopify variants for the selected colors
   * ---------------------------------------------------------
   */

let color1Variant = null;
let color2Variant = null;

if (isJournalProduct) {
  const cartJournalType =
    journalType.trim().toLowerCase() === '2 journals'
      ? '1 Journal'
      : journalType;

  color1Variant = findJournalVariant(
    cartJournalType,
    color1
  );

  color2Variant = color2
    ? findJournalVariant(cartJournalType, color2)
    : null;
} else {
  color1Variant = selectedVariant;
}

  /*
   * Validate the required variant lookup.
   */
    if (!color1Variant) {
      console.error('Could not find Shopify variant:', {
        journalType,
        color1,
        selectedVariantId,
        productVariants,
      });

      this.handleErrorMessage(
        isJournalProduct
          ? `Unable to find the Shopify variant for ${journalType} / ${color1}.`
          : 'Unable to find the selected Shopify variant.'
      );

      this.submitButton.removeAttribute('aria-disabled');
      this.submitButton.classList.remove('loading');
      this.querySelector('.loading__spinner').classList.add('hidden');

      return;
    }

  if (color2 && !color2Variant) {
    console.error('Could not find second Shopify variant:', {
      journalType,
      color2,
      productVariants,
    });

    this.handleErrorMessage(
      `Unable to find the Shopify variant for ${journalType} / ${color2}.`
    );

    this.submitButton.removeAttribute('aria-disabled');
    this.submitButton.classList.remove('loading');
    this.querySelector('.loading__spinner').classList.add('hidden');

    return;
  }

  /*
   * ---------------------------------------------------------
   * Line-item properties
   * ---------------------------------------------------------
   *
   * These can stay because they are useful for your existing
   * color/image functionality.
   *
   * The important difference is that the Shopify variant ID
   * is now the actual product identity/SKU.
   */

const lineProperties = (color, image) => {
  const properties = {};

  if (image) properties._color_image = image;

  return properties;
};

  const bundleDiscountCode =
    (this.dataset.bundleDiscountCode || '').trim();

  /*
   * A two-color selection means this is the 2 Journals
   * configuration.
   */
const isTwoJournalBundle =
  isJournalProduct &&
  Boolean(color2 && color2Variant);

  /*
   * ---------------------------------------------------------
   * Build cart items
   * ---------------------------------------------------------
   */

  let items = [];

  if (isTwoJournalBundle) {
    /*
     * 2 Journals:
     *
     * Add TWO REAL Shopify variants.
     *
     * Example:
     * Sage    -> JNL-J2-SAG
     * Graphite -> JNL-J2-GRA
     */

    items = [
      {
        id: Number(color1Variant.id),
        quantity: 1,
        properties: lineProperties(
          color1,
          color1Image
        ),
      },
      {
        id: Number(color2Variant.id),
        quantity: 1,
        properties: lineProperties(
          color2,
          color2Image
        ),
      },
    ];
  } else {
    /*
     * 1 Journal:
     *
     * Add ONE real Shopify variant.
     */
    items = [
      {
        id: Number(color1Variant.id),
        quantity: quantity,
        properties: lineProperties(
          color1,
          color1Image
        ),
      },
    ];
  }

  const config = fetchConfig('javascript');

  config.headers['X-Requested-With'] = 'XMLHttpRequest';
  config.headers['Content-Type'] = 'application/json';

  if (this.cart) {
    this.cart.setActiveElement(document.activeElement);
  }

  const requestBody = {
    items,
  };

  if (this.cart) {
    requestBody.sections = this.cart
      .getSectionsToRender()
      .map((section) => section.id);

    requestBody.sections_url = window.location.pathname;
  }

  config.body = JSON.stringify(requestBody);

  /*
   * For Dawn's cart update event, use the first actual
   * variant that was added.
   */
  const eventVariantId = String(color1Variant.id);
  const eventQuantity = isTwoJournalBundle ? 2 : quantity;

  const linesUpdateDeferred =
    this.createCartLinesUpdateEvent(
      eventVariantId,
      eventQuantity
    );

  fetch(`${routes.cart_add_url}`, config)
    .then((response) => response.json())
    .then((response) => {
      if (response.status) {
        publish(PUB_SUB_EVENTS.cartError, {
          source: 'product-form',
          productVariantId: eventVariantId,
          errors: response.errors || response.description,
          message: response.message,
        });

        this.handleErrorMessage(
          response.description
        );

        this.dispatchCartErrorEvent(
          response.description || response.message,
          'INVALID'
        );

        linesUpdateDeferred?.reject(
          new Error(
            response.description ||
            response.message
          )
        );

        const soldOutMessage =
          this.submitButton.querySelector(
            '.sold-out-message'
          );

        if (!soldOutMessage) return null;

        this.submitButton.setAttribute(
          'aria-disabled',
          true
        );

        this.submitButtonText.classList.add(
          'hidden'
        );

        soldOutMessage.classList.remove(
          'hidden'
        );

        this.error = true;

        return null;
      }

      /*
       * Keep your existing bundle discount behavior.
       */
      if (
        isTwoJournalBundle &&
        bundleDiscountCode
      ) {
        const discountConfig =
          fetchConfig('javascript');

        discountConfig.headers[
          'X-Requested-With'
        ] = 'XMLHttpRequest';

        discountConfig.body =
          JSON.stringify({
            discount: bundleDiscountCode,
            sections:
              requestBody.sections,
            sections_url:
              requestBody.sections_url,
          });

        return fetch(
          `${routes.cart_update_url}`,
          discountConfig
        )
          .then((discountResponse) =>
            discountResponse.json()
          )
          .then((discounted) =>
            discounted &&
            !discounted.status
              ? discounted
              : response
          )
          .catch(() => response);
      }

      return response;
    })
    .then((response) => {
      if (!response) return;

      if (!this.cart) {
        this.resolveCartLinesUpdate(
          linesUpdateDeferred
        );

        window.location =
          window.routes.cart_url;

        return;
      }

      this.resolveCartLinesUpdate(
        linesUpdateDeferred
      );

      const startMarker =
        CartPerformance.createStartingMarker(
          'add:wait-for-subscribers'
        );

      if (!this.error) {
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'product-form',
          productVariantId: eventVariantId,
          cartData: response,
        }).then(() => {
          CartPerformance.measureFromMarker(
            'add:wait-for-subscribers',
            startMarker
          );
        });
      }

      this.error = false;

      const quickAddModal =
        this.closest('quick-add-modal');

      if (quickAddModal) {
        document.body.addEventListener(
          'modalClosed',
          () => {
            setTimeout(() => {
              CartPerformance.measure(
                'add:paint-updated-sections',
                () => {
                  this.cart.renderContents(
                    response
                  );
                }
              );
            });
          },
          { once: true }
        );

        quickAddModal.hide(true);
      } else {
        CartPerformance.measure(
          'add:paint-updated-sections',
          () => {
            this.cart.renderContents(response);
          }
        );
      }
    })
    .catch((e) => {
      console.error(e);

      this.dispatchCartErrorEvent(
        e.message || 'Network error',
        'SERVICE_UNAVAILABLE'
      );

      linesUpdateDeferred?.reject(e);
    })
    .finally(() => {
      this.submitButton.classList.remove(
        'loading'
      );

      if (
        this.cart &&
        this.cart.classList.contains(
          'is-empty'
        )
      ) {
        this.cart.classList.remove(
          'is-empty'
        );
      }

      if (!this.error) {
        this.submitButton.removeAttribute(
          'aria-disabled'
        );
      }

      this.querySelector(
        '.loading__spinner'
      ).classList.add('hidden');

      CartPerformance.measureFromEvent(
        'add:user-action',
        evt
      );
    });
}

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      createCartLinesUpdateEvent(variantId, quantity) {
        const { CartLinesUpdateEvent } = window.StandardEvents || {};
        if (!CartLinesUpdateEvent) return null;

        const deferred = CartLinesUpdateEvent.createPromise();
        this.dispatchEvent(
          new CartLinesUpdateEvent({
            action: 'add',
            context: 'product',
            lines: [{ merchandiseId: variantId, quantity }],
            promise: deferred.promise,
          })
        );
        return deferred;
      }

      resolveCartLinesUpdate(deferred) {
        if (!deferred) return;
        const { CartLinesUpdateEvent } = window.StandardEvents || {};
        if (!CartLinesUpdateEvent) return;

        const pendingCartDataPromise = typeof CartItems !== 'undefined'
          ? CartItems.fetchCartData()
          : fetch(`${routes.cart_url}.json`).then((response) => response.json());

        pendingCartDataPromise
          .then((cart) => {
            if (!cart?.currency) return deferred.reject(new Error('Missing currency in cart response'));
            deferred.resolve({ cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart) });
          })
          .catch((e) => deferred.reject(e));
      }

      dispatchCartErrorEvent(message, code) {
        const { CartErrorEvent } = window.StandardEvents || {};
        if (!CartErrorEvent) return;
        this.dispatchEvent(new CartErrorEvent({ error: message, code }));
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
